import { render, staticRenderFns } from "./CreditQuota.vue?vue&type=template&id=08fc0964&"
import script from "./CreditQuota.vue?vue&type=script&lang=js&"
export * from "./CreditQuota.vue?vue&type=script&lang=js&"
import style0 from "./CreditQuota.vue?vue&type=style&index=0&id=08fc0964&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports